import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, BatteryWarning, Brain, Activity, Scale } from 'lucide-react';
export function PainAgitationSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  const painPoints = [{
    icon: BatteryWarning,
    text: 'Te despiertas cansad@, aunque hayas dormido 8 horas.'
  }, {
    icon: Brain,
    text: "Sientes esa 'neblina mental' y falta de energía a las 4 de la tarde."
  }, {
    icon: Scale,
    text: "Tu ropa favorita se queda guardada en el fondo del clóset porque 'ya no te queda'."
  }, {
    icon: Activity,
    text: 'Te da miedo ir al médico y que te hable de pre-diabetes o hígado graso.'
  }];
  return <section className="py-16 px-4 bg-white/40" data-id="element-86">
      <div className="max-w-3xl mx-auto" data-id="element-87">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-12" data-id="element-88">
          <h3 className="text-2xl sm:text-3xl font-bold text-[#2D1B06] mb-6" data-id="element-89">
            ¿Te ha pasado que te matas en el gimnasio, comes "lechuga y pollo" y
            la báscula no se mueve ni un gramo?
          </h3>
          <p className="text-lg text-[#2D1B06]/80 leading-relaxed" data-id="element-90">
            No te castigues. No es falta de voluntad. Es tu{' '}
            <strong className="text-[#DC2626]" data-id="element-91">Insulina</strong>. Cuando tus
            hormonas están bloqueadas, tu cuerpo entra en modo "almacenamiento"
            y es imposible bajar de peso, sin importar cuánto ejercicio hagas.
          </p>
        </motion.div>

        <div className="bg-[#FFF9F0] border-l-4 border-[#DC2626] p-8 rounded-r-2xl shadow-md mb-12" data-id="element-92">
          <h4 className="text-xl font-bold text-[#2D1B06] mb-6 flex items-center" data-id="element-93">
            <AlertCircle className="w-6 h-6 text-[#DC2626] mr-2" data-id="element-94" />
            Vivir con el metabolismo "roto" es agotador:
          </h4>

          <motion.ul variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} className="space-y-4" data-id="element-95">
            {painPoints.map((point, index) => <motion.li key={index} variants={itemVariants} className="flex items-start" data-id="element-96">
                <point.icon className="w-6 h-6 text-[#E8820C] mr-3 flex-shrink-0 mt-0.5" data-id="element-97" />
                <span className="text-lg text-[#2D1B06]/80" data-id="element-98">{point.text}</span>
              </motion.li>)}
          </motion.ul>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center bg-[#2D1B06] text-[#FFF9F0] p-8 rounded-2xl shadow-xl" data-id="element-99">
          <p className="text-xl font-medium leading-relaxed" data-id="element-100">
            <span className="text-[#E8820C] font-bold" data-id="element-101">Sé cómo se siente.</span>{' '}
            Pero tengo una noticia: Tu cuerpo no está roto. Solo necesita el
            "software" correcto para volver a quemar grasa como energía.
          </p>
        </motion.div>
      </div>
    </section>;
}